import React from 'react';
import axios from 'axios';
const authBearer = "Bearer fV9e9XYcxNKCP85GfupI2EA4d6ybXAYUbu6Z3oSj"; // MUSEO
// const authBearer = "Bearer 4kALfDlAapE5mEie8CunQBuNXMtCJFS0tpI1upyc"; // PAVONE

export async function startGame(ticket) {
  try {
    console.log("Trying startGame ticket: ",ticket);
    const url = "https://api.escapemarte.museoscienza.it/api/ticket/new";
    const bodyParameters = {
      ticket: ticket
      //ticket: 'ESP2022PVMFXLCQBZUN'
    };
    const config = {
        headers: {
          Authorization: authBearer,
          Accept: "application/json"
       }
    };
    const response = await axios.post(url,bodyParameters,config)
    console.log('Response startGame: ',response.data);
    return response.data;
  } catch(error) {
    console.log('catch error');
    return [];
  }
}

export async function updateState(uuid, room, step, pen) {
  try {
    console.log("Trying updateState u: ",uuid, " r: ",room, " s: ", step, " p: ", pen);
    const url = "https://api.escapemarte.museoscienza.it/api/ticket/"+uuid+"/step";
    const response = await axios.post(url, {
      room: room,
      step: step,
      penalty: pen
    },{
      headers:{
        Authorization: authBearer,
        Accept: "application/json"
      }
    })
    console.log('Response updateState: ',response.data);
    return response.data;
  } catch(error) {
    console.log('catch error updateState')
    return [];
  }
}

export async function setNickname(uuid, nick) {
  try {
    console.log("Trying setNickname u: ",uuid, " n: ",nick);
    const url = "https://api.escapemarte.museoscienza.it/api/ticket/"+uuid+"/nickname";
    const response = await axios.post(url, {
      nickname: nick
    },{
      headers:{
        Authorization: authBearer,
        Accept: "application/json"
      }
    })
    console.log('Response setNickname: ',response.data);
    return response.data;
  } catch(error) {
    console.log('catch error setNickname')
    return [];
  }
}


export async function validateTicket(uuid, pen) {
  try {
    console.log("Trying validateTicket u: ",uuid, " p: ", pen);
    const url = "https://api.escapemarte.museoscienza.it/api/ticket/"+uuid+"/validated";
    const response = await axios.post(url, {
      penalty: pen
    },{
      headers:{
        Authorization: authBearer,
        Accept: "application/json"
      }
    })
    console.log('Response validateTicket: ',response.data);
    return response.data;
  } catch(error) {
    console.log('catch error validateTicket')
    return [];
  }
}

export async function checkState(uuid) {
  try {
    //console.log("Trying checkState u: ",uuid,);
    const url = "https://api.escapemarte.museoscienza.it/api/ticket/"+uuid+"/check";
    const response = await axios.get(url,{
      headers:{
        Authorization: authBearer,
        Accept: "application/json"
      }
    })

    //console.log('Response checkState: ',response.data);
    return response.data;
  } catch(error) {
    console.log('catch error checkState')
    return [];
  }
}

export async function getStats(uuid) {
  try {
    console.log("Trying getStats u: ",uuid,);
    const url = "https://api.escapemarte.museoscienza.it/api/ticket/stats";
    const response = await axios.get(url,{
      headers:{
        Authorization: authBearer,
        Accept: "application/json"
      }
    })

    //console.log('Response checkState: ',response.data);
    return response.data;
  } catch(error) {
    console.log('catch error checkState')
    return [];
  }
}
